import React from 'react';
import cn from 'classnames';
import styles from './styles.module.css';

const ImageGallery = ({ images }) => {
  return (
    <div className={styles.gallery}>
      {images.map((image, index) => (
        <figure key={index} className={cn([styles.galleryItem, styles[`galleryItem${index + 1}`]])}>
          <img src={image.url} alt="img1" className={styles.image} />
           {index === 4 && <div className={styles.button}>+{images.length} Photos</div>}
        </figure>
      ))}
    </div>
  );
};

export default ImageGallery;
